import { toast } from "react-toastify";
import { apiURL } from "../../config";

export async function getOverviewTab(axiosPrivate, id) {
	return axiosPrivate
		.get(`${apiURL}/decision/receiver/overview-tab/${id}.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			console.error("Overview Tab API Error:", err);
			return err.response;
		});
}

export async function editOverviewTab(axiosPrivate, cb, id, data) {
	return axiosPrivate
		.patch(`${apiURL}/decision/maker/overview-tab/${parseInt(id)}.json`, data, {
			headers: { "Content-Type": "application/json" },
		})
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				toast.success("Description - updated");
				cb();
			} else {
				toast.error("Description - not updated, try again");
			}
			return res;
		})
		.catch((err) => {
			console.error("Overview Tab API Error:", err);
			throw err; // Re-throw to allow proper error handling in calling code
		});
}

export async function lockOverviewTab(axiosPrivate, cb, id, data) {
	return axiosPrivate
		.put(`${apiURL}/decision/overview-tab/block/${id}.json`, data, {
			headers: { "Content-Type": "application/json" },
		})
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				toast.success("Description locked");
				cb();
			} else {
				toast.error("Description - not locked, try again");
			}
			return res;
		})
		.catch((err) => {
			return err.response;
		});
}
